// extracted by mini-css-extract-plugin
export default {"articleWrapper":"article_articleWrapper__Mx8+A"};